
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./functions/optimizedResize');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('accordion', require('./components/Accordion.vue').default);
Vue.component('accordion-section', require('./components/AccordionSection.vue').default);
Vue.component('standard-filter-editor', require('./components/StandardFilterEditor.vue').default);
Vue.component('calendar', require('./components/Calendar.vue').default);
Vue.component('co2-make-model', require('./components/CO2MakeModel.vue').default);
Vue.component('co2-upload', require('./components/CO2Upload.vue').default);
Vue.component('co2-editor', require('./components/CO2Editor.vue').default);
Vue.component('member-certificate-upload', require('./components/MemberCertificateUpload.vue').default);
Vue.component('confirm', require('./components/Confirm.vue').default);
Vue.component('context-panel', require('./components/ContextPanel.vue').default);
Vue.component('count-up', require('./components/CountUp.vue').default);
Vue.component('dashboard-exporter', require('./components/DashboardExporter.vue').default);
Vue.component('dropdown-menu', require('./components/DropdownMenu.vue').default);
Vue.component('environment', require('./components/Environment.vue').default);
Vue.component('environment-switcher', require('./components/EnvironmentSwitcher.vue').default);
Vue.component('exporter', require('./components/Exporter.vue').default);
Vue.component('filter-manager', require('./components/FilterManager.vue').default);
Vue.component('filter-string', require('./components/FilterString.vue').default);
Vue.component('first-login', require('./components/FirstLogin.vue').default);
Vue.component('graph-exporter', require('./components/GraphExporter.vue').default);
Vue.component('help-centre-video', require('./components/HelpCentreVideo.vue').default);
Vue.component('loading-overlay', require('./components/LoadingOverlay.vue').default);
Vue.component('logout-form', require('./components/LogoutForm.vue').default);
Vue.component('members', require('./components/Members.vue').default);
Vue.component('main-menu', require('./components/MainMenu.vue').default);
Vue.component('mobile-menu', require('./components/MobileMenu.vue').default);
Vue.component('motorstats-upload', require('./components/MotorstatsUpload.vue').default);
Vue.component('overlay', require('./components/Overlay.vue').default);
Vue.component('percentage-change', require('./components/PercentageChange.vue').default);
Vue.component('roles', require('./components/Roles.vue').default);
Vue.component('sidebar', require('./components/Sidebar.vue').default);
Vue.component('stat-box', require('./components/StatBox.vue').default);
Vue.component('submenu', require('./components/Submenu.vue').default);
Vue.component('user-importer', require('./components/UserImporter.vue').default);
Vue.component('users', require('./components/Users.vue').default);
Vue.component('wltp-make-model', require('./components/WltpMakeModel.vue').default);
Vue.component('statcode-form', require('./components/StatcodeForm.vue').default);

// Reporting
Vue.component('bar-chart', require('./components/reporting/Bar.vue').default);
Vue.component('doughnut-chart', require('./components/reporting/Doughnut.vue').default);
Vue.component('graph-legend', require('./components/reporting/GraphLegend.vue').default);
Vue.component('high-map', require('./components/reporting/HighMap.vue').default);
Vue.component('line-chart', require('./components/reporting/Line.vue').default);
Vue.component('pie-chart', require('./components/reporting/Pie.vue').default);
Vue.component('podium', require('./components/reporting/Podium.vue').default);
Vue.component('responsive-table', require('./components/reporting/ResponsiveTable.vue').default);
Vue.component('percentage-change-bar', require('./components/reporting/PercentageChangeBar.vue').default);
Vue.component('table-expander', require('./components/reporting/TableExpander.vue').default);
Vue.component('table-expansion', require('./components/reporting/TableExpansion.vue').default);

// Forms
Vue.component('dropzone', require('./components/forms/Dropzone.vue').default);
Vue.component('help-center-form', require('./components/forms/HelpCenterForm.vue').default);
Vue.component('motorstats-notifications-form', require('./components/forms/MotorstatsNotificationsForm.vue').default);

// Surveys
Vue.component('feedback-survey', require('./components/forms/surveys/FeedbackSurvey.vue').default);

// Filters
Vue.component('light-commercial-filters', require('./components/filters/LightCommercials.vue').default);
Vue.component('heavy-commercial-filters', require('./components/filters/HeavyCommercials.vue').default);
Vue.component('passenger-car-filters', require('./components/filters/PassengerCars.vue').default);

// Dashboards
Vue.component('passenger-cars-dashboard', require('./components/dashboards/motorstats/passengerCars/Dashboard.vue').default);
Vue.component('passenger-cars-show', require('./components/dashboards/motorstats/passengerCars/Show.vue').default);
Vue.component('light-commercials-dashboard', require('./components/dashboards/motorstats/lightCommercials/Dashboard.vue').default);
Vue.component('light-commercials-show', require('./components/dashboards/motorstats/lightCommercials/Show.vue').default);
Vue.component('heavy-commercials-dashboard', require('./components/dashboards/motorstats/heavyCommercials/Dashboard.vue').default);
Vue.component('heavy-commercials-show', require('./components/dashboards/motorstats/heavyCommercials/Show.vue').default);

// Passport Components
Vue.component('passport-clients', require('./components/passport/Clients.vue').default);
Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients.vue').default);
Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens.vue').default);

// Public
Vue.component('public-light-commercial-filters', require('./components/filters/public/LightCommercials.vue').default);
Vue.component('public-heavy-commercial-filters', require('./components/filters/public/HeavyCommercials.vue').default);
Vue.component('public-passenger-car-filters', require('./components/filters/public/PassengerCars.vue').default);
Vue.component('public-mobile-menu', require('./components/PublicMobileMenu.vue').default);

// Order Forms
Vue.component('admin-order-forms-index', require('./components/admin/orderForms/Index').default);

window.bus = new Vue({});

const app = new Vue({
    el: '#app',
});
